import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { useActions } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AIFailureHelp',
    props: {
        runFailCause: null,
        feedId: null,
        queries: null
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        const runFailAIResponse = ref(null);
        const { create: promptAI } = useActions('ai-query-helper', ['create']);
        async function askAIAboutFail() {
            const response = await promptAI({
                feedId: props.feedId,
                message: `Act as SQL developer. I have met error ${props.runFailCause} while running this queries: ${JSON.stringify(props.queries.map((query) => ({
                    sql: query.code,
                    name: query.name,
                    priority: query.priority
                })))}. Please explain me error and point, which query is causing this error and how to fix it.`
            });
            runFailAIResponse.value = response?.message;
        }
        return { __sfc: true, props, emit, runFailAIResponse, promptAI, askAIAboutFail };
    }
});
